"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkOrder = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../../common");
const enums_1 = require("../../enums");
class CreateWorkOrder extends common_1.BaseAction {
}
__decorate([
    class_validator_1.IsMongoId()
], CreateWorkOrder.prototype, "productId", void 0);
__decorate([
    class_validator_1.IsMongoId(),
    class_validator_1.IsOptional()
], CreateWorkOrder.prototype, "locationId", void 0);
__decorate([
    class_validator_1.IsEnum(enums_1.WorkOrderType)
], CreateWorkOrder.prototype, "type", void 0);
__decorate([], CreateWorkOrder.prototype, "dueDate", void 0);
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.IsPositive()
], CreateWorkOrder.prototype, "qtyRequired", void 0);
__decorate([
    class_validator_1.IsMongoId()
], CreateWorkOrder.prototype, "customerId", void 0);
__decorate([
    class_validator_1.IsString()
], CreateWorkOrder.prototype, "customerPartNumber", void 0);
exports.CreateWorkOrder = CreateWorkOrder;
//# sourceMappingURL=create-work-order.action.js.map